import { Component, Input, Output, EventEmitter, ViewChild, SimpleChanges, OnInit, OnChanges, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Subtitle } from 'app/components/library/mediaclip/subtitle-quickedit.component';
import toWebVTT from 'srt-webvtt';
@Component({
	selector: 'basic-player',
	templateUrl: './basic-player.component.html',
	styleUrls: ['./basic-player.component.scss']
})

export class BasicPlayerComponent implements OnInit, OnChanges, AfterViewInit {
	@ViewChild('media', { static: true }) mediaElement: any;

	@Input() srcFile: string;
	@Input() settings: {
		autoplay?: boolean;
		autounmute?: boolean;
		crossorigin?: string;
		preload?: string;
	};
	@Input() size16_9 = false;
	@Input() mediatype: 'audio' | 'video';
	@Input() subtitle: Subtitle;
	@Input() srt: string;

	// pass height to fit video to height immediately without resize flicker
	@Input() height?: number = null;

	@Output() onChange: EventEmitter<any> = new EventEmitter<any>();
	@Output() durationchange: EventEmitter<number> = new EventEmitter<number>();
	@Output() onTimeUpdated: EventEmitter<number> = new EventEmitter<number>();

	trustedSrc: string;
	public status: any;
	public media: HTMLVideoElement | HTMLAudioElement;
	mediaError: MediaError;
	webVtt: SafeUrl;
	showSubtitleSet = false;

	constructor(
		private sanitizer: DomSanitizer
	) {
		this.settings = {
			autoplay: false,
			autounmute: false
		};
		this.status = {
			playing: false,
			currentTime: 0
		};
	}

	ngOnInit() {
		this.media = this.mediaElement.nativeElement;
		'loadedmetadata playing pause timeupdate durationchange volumechange loadstart error'.split(' ').forEach((evName) => {
			this.media.addEventListener(evName, (ev: Event) => {
				this.onEvent(ev);
			});
		});

		this.status.volume = this.media.volume = this.settings?.autounmute ? 1 : 0;
		this.durationchange.emit(this.media.duration);
	}

	ngAfterViewInit(): void {
		this.convertSubtitleToWebVtt();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.srcFile?.currentValue && this.trustedSrc !== changes.srcFile.currentValue) {
			this.trustedSrc = changes.srcFile.currentValue;
		}

		if (changes.srt?.currentValue) {
			this.convertSubtitleToWebVtt();
		}
	}

	convertSubtitleToWebVtt(): void {
		if (!this.subtitle?.srt && this.subtitle?.srt !== '') {
			return;
		}

		const subBlob = new Blob([this.subtitle.srt]);
		toWebVTT(subBlob)
			.then(result => {
				// tell Angular the src is trusted
				this.webVtt = this.sanitizer.bypassSecurityTrustUrl(result);
				this.displaySubtitle();
			})
			.catch(e => {
				console.warn(e.message);
			});
	}

	displaySubtitle(): void {
		if (this.showSubtitleSet) {
			return;
		}

		if (this.subtitle) {
			// waiting <track> render ready
			setTimeout(() => {
				this.media.textTracks[0].mode = 'showing';
				(this.media.textTracks[0] as any).default = true; // safari with custom controls
				this.showSubtitleSet = true;
			});
		};
	}

	public setCurrentTime(currentTime) {
		if (!isNaN(currentTime)) {
			this.media.currentTime = currentTime;
		}
	}

	onEvent(ev: Event) {
		switch (ev.type) {
			case 'error':
				this.mediaError = this.media.error;
				break;
			case 'durationchange':
				this.status.duration = Math.round(this.media.duration);
				this.onTimeUpdate(ev);
				this.durationchange.emit(this.media.duration);
				break;

			case 'playing':
				this.status.playing = true;
				break;

			case 'pause':
				this.status.playing = false;

				break;

			case 'timeupdate':
				this.onTimeUpdate(ev);

				break;

			case 'volumechange':
				this.status.volume = this.media.volume;

				break;

			case 'loadstart':
				this.status.currentTime = 0;
				break;

			default:
				this.mediaError = null;
				break;

		}
	}

	onTimeUpdate(ev: Event) {
		this.status.currentTime = this.media.currentTime;
		this.status.progress = this.media.currentTime;
		this.onTimeUpdated.emit(this.media.currentTime);
	}

	playPause() {
		if (this.status.playing) {
			this.media.pause();
		} else {
			this.media.play();
		}
	}

	toggleMute() {
		if (this.status.volume === 0) {
			this.media.volume = 1;
		} else {
			this.media.volume = 0;
		}
	}

	sliderChangedEvent(event: any) { // MsSliderChange
		if (event.srcElement && (event.srcElement.value || event.srcElement.value === 0)) {
			this.media.currentTime = event.srcElement.value;
		}
	}

	sliderChanged(value: number) { // MsSliderChange
		if (value || value === 0) {
			this.media.currentTime = value;
		}
	}
}
